import { BrowserRouter, Route, Routes } from 'react-router-dom';

import SuporteRedirectPage from '../views/home_v1/SuporteRedirectPage';
import AboutPage from '../views/home_v1/sections/aboutSection/AboutPage';
import VacancySection from '../views/home_v1/sections/VacancySection/VacancySection';
import ContactSection from '../views/home_v1/sections/contactSection/ContactSection';

function Router() {
    return (
        <BrowserRouter>
            <Routes>
                {/* Landing page */}
                <Route path="/" element={<AboutPage />} />
                <Route path="/sobre-nos" element={<AboutPage />} />
                <Route path="/trabalhe-conosco" element={<VacancySection />} />
                <Route path="/contato" element={<ContactSection />} />

                <Route path="/suporte/*" element={<SuporteRedirectPage />} />
            </Routes>
        </BrowserRouter>
    );
}

export default Router;